import { apiGet, apiPost, API_URI, CRM_API_URI } from "api";
import { ContactType } from "types";

const user = {
  get: async () => {
    //Not proud of it :-(
    try {
      const data = await apiGet(`${API_URI}/api/user/get`);
      return data;
    }
    catch {
      window.location.href = "/login"
    }
  },
  getUser: () => {
    const data = apiGet(`${API_URI}/api/user/get`);
    return data;
  },
  getById: async (id: number): Promise<ContactType> => {
    const data = await apiGet(`${CRM_API_URI}/api/user/get?id=${id}`);
    return data;
  },
  login: async (email: string, password: string) => {
    const data = await apiPost(`${CRM_API_URI}/api/user/login?email=${email}&password=${password}`, { Password: password, Username: email });
    return data;
  },
  getIdByEmail: async (email: string) => {
    const data = await apiPost(`${API_URI}/api/user/get/email`, { Email: email });
    return data;
  },
  loginWithId: async (id: number) => {
    const data = await apiPost(`${CRM_API_URI}/api/user/login/id?contactId=${id}`);
    return data;
  },
  forgotPassword: async (email: string) => {
    const data = await apiPost(`${API_URI}/api/user/forgotpassword?email=${email}`);
    return data;
  },
};

export default user;
